import { Component, EventEmitter, OnInit, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { BadgeSelectorService } from '../badge-selector/badge-selector.service';
import { ColorPicker } from 'primeng/colorpicker';
import { CvConfigurationService } from '../services/cv-configuration.service';
import { CvCustomDialogService } from '../custom-dialog/cv-custom-dialog.service';
import { CvDialogService } from '../confirm-dialog/cv-dialog.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cv-custom-badge-creator',
  templateUrl: './custom-badge-creator.component.html',
  styleUrls: ['./custom-badge-creator.component.scss']
})
export class CustomBadgeCreatorComponent implements OnInit, OnChanges {
  @Input() showWhen: boolean;
  @Input() badgeType: string;
  @Output() onSave: EventEmitter<number> = new EventEmitter<number>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  bss: any = null;
  isIEorEdge: boolean = false;

  Views: any = {
    Upload: 0,
    Size: 1,
    Color: 2
  }

  view: number = this.Views.Upload;

  croppedImage: any = null;
  displayImagePicker: boolean = false;
  scale: number = 75;
  cropStates: any = {
    Unknown: 0,
    Cropping: 1,
    Cropped: 2
  };

  cropState: number = this.cropStates.Unknown;
  insideColor: string = "#FFFFFF";
  borderColor: string = "#000000";
  dropAllowed: boolean = false;
  acceptedFileTypes: string = "image/png"; //"image/png,image/jpg";
  uploadedInvalidFileFormat: boolean = false;
  nextButtonDisabled: boolean = true;
  isSaving: boolean = true;

  uploadedImageString: any = "";
  imageUploaded: boolean = false;
  imageID: number;
  dropEventHandle: any;

  sliderConfig: any;

  constructor(
    private badgeSelectorService: BadgeSelectorService,
    private dialogService: CvDialogService,
    private localizationService: CVLocalizationService,
    public cvConfigurationService: CvConfigurationService,
    private customDialogService: CvCustomDialogService,
  ) { 
    this.bss = this.badgeSelectorService.data;
    this.init();
  }

  ngOnInit(): void {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') !== -1) {
      // IE11 Bugfix: (modal height needs to be specified)
      this.isIEorEdge = true;
    }

    this.sliderConfig = {
      connect: true,
      range: { min: 0, max: 100 },
      step: 1,
      tooltips: [true],
      behaviour: 'drag'
    };  
  }

  resetVariables (): void {
    this.croppedImage = null;
    this.displayImagePicker = false;
    this.scale = 75;
    this.cropState = this.cropStates.Unknown;
    this.dropAllowed = false;
    this.uploadedInvalidFileFormat = false;
    this.nextButtonDisabled = true;
    this.isSaving = false;
    this.insideColor = "#FFFFFF";
    this.borderColor = "#000000";
    this.uploadedImageString = "";
    this.imageUploaded = false;            
  }

  ngOnChanges(changes: SimpleChanges): void{
    if(changes.showWhen != undefined && changes.showWhen != null){
      if(changes.showWhen.currentValue){
        $("body").addClass("cvGSstopScrolling");
        //$scope.$broadcast("CVEvents.CustomBadges.Show");
        this.resetVariables();
      }
      else{
        $("body").removeClass("cvGSstopScrolling");
        //$scope.$broadcast("CVEvents.CustomBadges.Hide");
      }
    }
  }

  init (){
    this.initUpload();
  }

  NextStep (): void {
    if (this.nextButtonDisabled)
      return;

    switch (this.view) {
        case this.Views.Upload: this.view = this.Views.Size; break;
        case this.Views.Size: this.view = this.Views.Color; break;
        case this.Views.Color: //Should never hit this as it should save instead
          break;
    }
  }

  PrevStep (): void {
    switch (this.view) {
        case this.Views.Color: this.view = this.Views.Size; break;
        case this.Views.Size: this.view = this.Views.Upload; break;
        case this.Views.Upload: //Should never hit this as upload is the first tab and back should be hidden
            break;
    }
  }

  Save() {
    if (this.isSaving)
        return false;

    this.isSaving = true;

    let badgeData = {
      bitString: this.uploadedImageString, 
      bkgColor: this.insideColor, 
      brdColor: this.borderColor, 
      scalePercent: this.scale
    }

    this.badgeSelectorService.saveCustomBadge(badgeData, this.badgeType).then(
      (result: any) => {
        if (result.status_code == 200) {
          this.onSave.emit(result.data);
          this.isSaving = false;
          this.resetTool();
        }
        else {
          showErrorMessage(this.localizationService.getCachedText("Custom_Badges", "Failed_Create_Custom_Badge", "Failed to Create Custom Badge"), result.message, false, ()=>{} );
          this.isSaving = false;
        }                    
      },
      (error) => {
        showErrorMessage(this.localizationService.getCachedText("Custom_Badges", "Failed_Create_Custom_Badge", "Failed to Create Custom Badge"), error.message, false, ()=>{} );
        this.isSaving = false;
      }
    );
  }

  Cancel(): void {
    const title = this.localizationService.getCachedText("Common", "Confirm_Cancel", "Confirm Cancel");
    const message = this.localizationService.getCachedText("Common", "Confirm_Cancel_Msg", "Are you sure you want to cancel? Your current progress will be lost.");
  
    if (this.cvConfigurationService.isCxOne) {
      const modalOptions: NgbModalOptions = {
        keyboard: false,
        backdrop: 'static',
        centered: true,
        windowClass: 'cxone-badge-warning-modal'
      };
  
      this.customDialogService.showDialog(
        title,
        `<div class="modal-body-text"> ${message} </div>`,
        11,
        this.localizationService.getCachedText("Common", "Cancel_Button", "Cancel"),
        this.localizationService.getCachedText("Common", "OK", "OK"),
        true,
        () => {
          this.onCancel.emit();
          this.resetTool();
        },
        () => {}, // No action on cancel
        '',
        true,
        modalOptions
      );
    } else {
      this.dialogService.showConfirmDialog(
        title,
        message, 
        false,
        () => {
          this.onCancel.emit();
          this.resetTool();
        }
      );
    }
  }

  resetTool (): void {
    this.resetVariables();
    this.view = this.Views.Upload;
  }

  /*******REGION UPLOAD CODE SETUP*********/
  uploadImage() {
    let fileinput = $('.CustomBadgeFileUpload');
    fileinput.click();
  }

  handleFileSelect (event: Event): any {    
    this.nextButtonDisabled = true;

    const element = event.currentTarget as HTMLInputElement;
    let file: File = element.files[0];

    if (!this.validateFileFormat(file.type))
      return false;

    this.uploadedInvalidFileFormat = false; //reset error message on accepted upload

    let reader = new FileReader();
    reader.onload = ((evt) => {
      setTimeout(() => {
        this.imageID = 0;
        this.uploadedImageString = evt.target.result;
        this.imageUploaded = true;
        this.displayImagePicker = true;
        this.cropState = this.cropStates.Cropping;
      });
    });
    reader.readAsDataURL(file);
  }

  validateFileFormat(format: any): boolean {
    let accepted = this.acceptedFileTypes.split(',');
    if (accepted.indexOf('*') > -1)
        return true;
    if (accepted.indexOf(format) > -1)
        return true;

    this.uploadedInvalidFileFormat = true;
    this.dropAllowed = false;
    return false;
  }

  initUpload() {
    $("body").on('drop', this.handleFileDrop);
    $("body").on('dragenter dragleave mouseenter mouseleave mousemove', '.SpotlightManualPreviewBox', this.setDropAllowed);
    $("body").on('dragleave mouseleave', '.CustomBadgeFileUpload', this.setDropAllowed);
  }

  handleFileDrop = function (evt: any) {
    evt.preventDefault();
    evt.stopPropagation();

    let file = evt.originalEvent.dataTransfer.files[0];

    if (!this.validateFileFormat(file.type))
      return false;

    this.uploadedInvalidFileFormat = false; //reset error message on accepted upload

    let reader = new FileReader();
    reader.onload = ((evt) => {
      setTimeout(() => {
        this.imageID = 0;
        this.uploadedImageString = evt.target.result;
        this.imageUploaded = true;
        this.displayImagePicker = true;
        this.cropState = this.cropStates.Cropping;
      });
    });
    reader.readAsDataURL(file);
  }

  acceptImageUpload(): void {
    this.displayImagePicker = false;
    this.uploadedImageString = this.croppedImage;
    this.cropState = this.cropStates.Cropped;
    this.nextButtonDisabled = false;
  }

  cancelImageUpload(): void {
    this.uploadedImageString = null;
    this.croppedImage = null;
    this.imageUploaded = false;
    this.displayImagePicker = false;

    //$('.CustomBadgeFileUpload')[0].value = "";
  }

  setDropAllowed = function (evt: any) {
    setTimeout(() => {
      if (evt != null && evt.type == "mouseleave" || evt.type == "dragleave") {
        
        //check if the mouse is outside of the circle
        let distance = Math.sqrt(Math.abs(Math.pow(evt.offsetX - 150, 2)) + Math.abs(Math.pow(evt.offsetY - 150, 2)));
        if (distance > 150) {
          this.dropAllowed = false;
          this.dropEventHandle = null;
        }
        return;
      }

      if (evt != null && evt.originalEvent != null && evt.originalEvent.dataTransfer != null && evt.originalEvent.dataTransfer.files != null) {
        this.dropAllowed = true;
        this.dropEventHandle = null;
      }
      else {
        this.dropAllowed = false;
        this.dropEventHandle = null;
      }
    });
  }

  setCroppedImage(event: any): void {
    if (event.base64 !== undefined) {
      this.croppedImage = event.base64;
    } else {
      fetch(event.objectUrl)
      .then(response => response.blob())
      .then(blob => {      
          const reader = new FileReader();
          reader.onload = () => {          
              this.croppedImage = reader.result as string;
          };
          reader.readAsDataURL(blob); 
      });
    }  
  }

  updateScale(event: any): void {
    this.scale = event;
  }

  onColor1Changed(color1: ColorPicker): void{
    color1.writeValue(color1.inputBgColor);
    color1.onModelChange(color1.inputBgColor);
  }

  addInputField(input: number): void {
    $(".p-colorpicker-panel").append(
      '<div id="hex-field' + input + '" style="font-size: 11px" class="d-flex w-100 position-absolute fixed-bottom">\
        <div style="padding: 8px 0px 4px 8px" class="d-flex flex-row">\
          <div class="text-right" style="width: 35%">\
            <label style="color: white" class="pt-1">Hex color:</label>\
          </div>\
          <div class="pl-2" style="width: 65%">\
            <input input="inputColor' + input + '" type="text" style="width: 95%" [ngModelOptions]="{standalone: true}" \
              [(ngModel)]="foreColor' + input + '.inputBgColor" (change)="onColor1Changed(foreColor' + input + ')">\
          </div>\
        </div>\
      </div>'
    );
  }
  
  
  /* <input input="inputColor1" type="text"   />*/ 

  removeInputField(input: number): void {
    $('#hex-field' + input).remove();
  }
  /*******ENDREGION UPLOAD CODE SETUP*********/
}
